export const rules ={
        name: [
        { required: true, message: "请输入场馆名!", trigger: "blur" },
      ],
     
    }